module.exports = __webpack_public_path__ + "static/media/foreground2.3043fe0f.png";